<!-- @format -->

<template>
  <DocumentLayout>
    <h1 class="h1--hero">
      <div class="hero-h-wrapper">
        <div data-w-id="a57a7ba6-1456-df65-733e-c340ef917366" class="h--super-large">
          {{ $t("privacyPolicy.Privacy") }}
        </div>
      </div>
      <div class="hero-h-wrapper">
        <div data-w-id="201b457d-0993-bca7-76e5-88cdccd4a159" class="h--super-large">
          {{ $t("privacyPolicy.Policy") }}
        </div>
      </div>
    </h1>
    {{ locale }}
    <div class="base--wrapper">
      <PrivacyPoliceEn v-if="locale === 'en'" />
      <PrivacyPoliceCz v-if="locale === 'cz'" />
    </div>
  </DocumentLayout>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API

import { DocumentLayout } from "@/layout";
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
import PrivacyPoliceEn from "@/locales/privacypolice/PrivacyPoliceEn.vue";
import PrivacyPoliceCz from "@/locales/privacypolice/PrivacyPoliceCz.vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});
</script>

<style lang="scss" scoped>
.base--wrapper {
  color: #fff;
}
.h1--hero {
  width: 100%;
}
ul {
  li {
    color: #fff !important;
  }
}
.global--padding {
  p {
    color: #fff;
  }

  ul {
    li::marker {
      color: #fff;
      font-weight: bold;
    }
  }

  h2,
  h3 {
    padding-top: 1em;
    padding-bottom: 0.5em;
    color: #fff;
    text-align: left !important;
  }

  ol {
    margin-left: 20px;

    li::marker {
      color: #fff;
      font-weight: bold;
      font-size: 3em;
      font-family: Made Outer Sans, sans-serif;
    }

    &.litle li::marker {
      font-size: 14px;
    }
  }
}
</style>
